module.exports = __webpack_public_path__ + "static/assets/478b263b784a50b400d14cdd841dbfa3.svg";